import { CONFIGURATION_TYPES } from 'constants/enums'
import {get} from "lodash";

export default function(orgId, fields, options = {}, fileUrl) {
  let configValueMap = {}

  for (const [key, cfgData] of Object.entries(options.configOptionsMap)) {
    configValueMap[key] = {}

    if (cfgData.type === CONFIGURATION_TYPES.boolean.id) {
      configValueMap[key].booleanValue = fields[cfgData.fieldName]
    }

    if (cfgData.type === CONFIGURATION_TYPES.integer.id) {
      configValueMap[key].intValue = fields[cfgData.fieldName]
    }

    if (cfgData.type === CONFIGURATION_TYPES.decimal.id) {
      configValueMap[key].decimalValue = fields[cfgData.fieldName]
    }

    if (cfgData.type === CONFIGURATION_TYPES.codeListValueTranslated.id) {
      configValueMap[key].codeListValue = {
        id: fields[cfgData.fieldName]
      }
    }

    if (cfgData.type === CONFIGURATION_TYPES.text.id) {
      configValueMap[key].textValue = fields[cfgData.fieldName]
    }

    if (cfgData.type === CONFIGURATION_TYPES.blob.id) {
      configValueMap[key].fileUrl = fileUrl || ''
    }

    if (cfgData.type === CONFIGURATION_TYPES.textTranslated.id) {
        configValueMap[key] = {
          translatedText: fields[cfgData.fieldName],
          translationKey: cfgData.translationKey
        }
    }

    const includeId = (orgId == get(cfgData, 'orgId'))

    if (includeId) {
      configValueMap[key] = {
        ...configValueMap[key],
        id: cfgData.id
      }
    }
  }

   const requestBody = {
    organizationId: orgId,
    localeId: fields.localeId,
    propagateToAllLangs: fields.propagateToAllLangs,
    configValueMap
  }

  return requestBody
}
